<template>
  <div class="compose-step">
    <el-card shadow="never">
      <template #header>
        <div class="card-header">
          <span>视频合成</span>
        </div>
      </template>

      <div class="compose-content">
        <el-result
          icon="success"
          title="所有步骤已完成"
          sub-title="点击下方按钮合成最终视频"
          v-if="!finalVideo"
        >
          <template #extra>
            <el-button type="primary" size="large" @click="composeVideo" :loading="composing">
              <el-icon><VideoPlay /></el-icon>
              开始合成最终视频
            </el-button>
          </template>
        </el-result>

        <div v-else class="final-video">
          <h3>最终视频</h3>
          <video :src="finalVideo.url" controls class="video-player" />
          <div class="video-actions">
            <el-button type="primary" @click="downloadVideo">
              <el-icon><Download /></el-icon>
              下载视频
            </el-button>
            <el-button @click="resetCompose">
              <el-icon><RefreshLeft /></el-icon>
              重新合成
            </el-button>
          </div>
        </div>
      </div>
    </el-card>

    <el-card class="summary-card" shadow="never" v-if="projectStore.project">
      <template #header>
        <span>项目摘要</span>
      </template>
      <el-descriptions :column="2" border>
        <el-descriptions-item label="项目名称">
          {{ projectStore.project.project_name }}
        </el-descriptions-item>
        <el-descriptions-item label="项目状态">
          <el-tag type="success">已完成</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="场景数量">
          {{ sceneCount }}
        </el-descriptions-item>
        <el-descriptions-item label="视频时长">
          {{ totalDuration }}秒
        </el-descriptions-item>
      </el-descriptions>
    </el-card>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import { ElMessage } from 'element-plus'
import { useProjectStore } from '../../stores/project'

const props = defineProps({
  projectId: {
    type: Number,
    required: true
  }
})

const projectStore = useProjectStore()
const composing = ref(false)
const finalVideo = ref(null)

const sceneCount = computed(() => {
  // 从剧本中获取场景数量
  return 0
})

const totalDuration = computed(() => {
  // 计算总时长
  return 0
})

const composeVideo = async () => {
  composing.value = true
  try {
    // 调用API合成视频
    await new Promise(resolve => setTimeout(resolve, 2000))
    finalVideo.value = {
      url: 'https://example.com/final-video.mp4'
    }
    ElMessage.success('视频合成成功')
  } catch (error) {
    ElMessage.error('视频合成失败')
  } finally {
    composing.value = false
  }
}

const downloadVideo = () => {
  if (finalVideo.value?.url) {
    window.open(finalVideo.value.url, '_blank')
  }
}

const resetCompose = () => {
  finalVideo.value = null
}
</script>

<style scoped lang="scss">
.compose-step {
  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}

.compose-content {
  padding: 40px 0;
}

.final-video {
  text-align: center;
  
  h3 {
    margin-bottom: 20px;
  }
  
  .video-player {
    max-width: 100%;
    max-height: 500px;
    border-radius: 8px;
    margin-bottom: 20px;
  }
  
  .video-actions {
    display: flex;
    justify-content: center;
    gap: 12px;
  }
}

.summary-card {
  margin-top: 20px;
}
</style>
